import React, { useEffect, useState } from 'react';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import CircularProgress from '@mui/material/CircularProgress';
import { useSelector } from 'react-redux';
import { Skeleton, ThemeProvider, createTheme } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { Subject } from '../../Objects/models/Subject';
import { store } from '../../Redux/store';
import { getSubject } from '../../Redux/Actions/PunctualCourseActions';
import { useTailwindBrand } from '../shared';
import { getActiveAppBrandConfig, getActiveBrandConfig, getActivePrestationBrandConfig } from '../../config/environment.config';

// store.dispatch(getSubject())

export default function SelectMatiereFields(props: any) {
  const { classes, brandConfig } = useTailwindBrand()
  const options = useSelector((state: any) => state?.punctualCourse?.subject)
  const navigate = useNavigate()
  const [selectedSubject, setSelectedSubject] = useState<Subject | null>(props?.value || null);
  const [open, setOpen] = useState(false);
  const [subject, setSubject] = useState<any>();
  const loading = open && options?.length === 0;
  const teachr = useSelector((state: any) => state?.user?.currentUser?.teachr);
  useEffect(() => {
    store.dispatch(getSubject(teachr?.id))
  }, [teachr?.id]);

  const theme = createTheme({
    components: {
      MuiAutocomplete: {
        styleOverrides: {
          option: {
            fontFamily: brandConfig.fontFamily,
          },
        },
      },
    },
  });

  useEffect(() => {
    if (props?.matieres) {
      if (props?.matieres !== selectedSubject) {
        setSelectedSubject(selectedSubject);
        props.callBack(selectedSubject);
        if (selectedSubject === null) {
          setSelectedSubject(props?.matieres);
          props.callBack(props?.matieres);
        }
      } else {
        setSelectedSubject(props.matieres);
        props.callBack(props.matieres);
      }
    }
  }, [props.matieres]);

  return (
    <>
      {
        options?.length === 0 ?
          <div className='lg:text-base text-xs text-center'>Aucune discipline n’est enregistrée sur votre compte {getActiveAppBrandConfig()}. <button className={`${classes.primaryText} font-bold  underline cursor-pointer`} onClick={() => navigate(`/${getActiveBrandConfig()}/tableau-de-bord/parametre`)}>Cliquez ici </button> pour ajouter vos disciplines.</div> :
          <>
            {!options ? <Skeleton variant="rounded" animation="wave" width="100%" height={60} /> :
              <div className={`relative cursor-not-allowed ${props.shadow ?? `shadow-dashboard-setup-input px-4 rounded-lg  ${classes.input}`}  h-max`}>
                <label className='block lg:text-base cursor-not-allowed font-bold'>{props?.label}</label>
                <ThemeProvider theme={theme}>
                  <Autocomplete
                    sx={{ "& .MuiOutlinedInput-root": { fontFamily: brandConfig.fontFamily } }}
                    id="dubjects-select"
                    fullWidth
                    open={open}
                    classes={{}}
                    onOpen={() => {
                      setOpen(true);
                    }}
                    onClose={() => {
                      setOpen(false);
                    }}
                    multiple={false}
                    clearIcon=""
                    noOptionsText={
                      subject === "Maths" || subject === "maths" ? (
                        <span className={`${classes.fontFamily}`}>
                          Écrivez plutôt Mathématiques dans la barre de recherche 😊
                        </span>
                      ) : (
                        <span className={`${classes.fontFamily}`}>
                          {getActivePrestationBrandConfig("", "Ce ", "Cette")} ne fait pas partie de votre liste de {getActivePrestationBrandConfig()}. <br/>
                          Merci de ne choisir qu’{getActivePrestationBrandConfig("", "un seul ", "une seule ")} élément dans la liste.<br/>
                          Si vous souhaitez ajouter {getActivePrestationBrandConfig("", "ce ", "cette")} à votre liste de {getActivePrestationBrandConfig()}, rendez-vous dans
                          <button className={`${classes.primaryText} font-bold underline cursor-pointer`} onClick={() => navigate(`/${getActiveBrandConfig()}/tableau-de-bord/parametre`)}> Paramètres {">"} Profil {">"} Mes {getActivePrestationBrandConfig()}</button>.
                        </span>
                      )
                    }
                    value={selectedSubject} // Utilise l'état pour contrôler la valeur
                    onChange={(event, newValue) => {
                      if (newValue !== selectedSubject) {
                        setSelectedSubject(newValue);
                        props.callBack(newValue); // Si nécessaire, invoquez le callback avec la nouvelle valeur
                      } else {
                        setSelectedSubject(newValue);
                        props.callBack(newValue); // Si nécessaire, invoquez le callback avec la nouvelle valeur
                      }
                    }}
                    isOptionEqualToValue={(option, value) => option?.fr_FR === value?.fr_FR}
                    getOptionLabel={(option) => option?.fr_FR}
                    options={options}
                    loading={loading}
                    loadingText={options?.length === 0 ? "Ajouter vos disciplines sur votre profil" : "chargement ..."}
                    popupIcon=""
                    renderTags={(value, getTagProps) =>
                      value.map((option, index) => (
                        <span
                          key={index}
                          className={
                            `${classes.fontFamily} lg:text-lg md:text-md text-sm` + props.customEdit
                          }
                        >
                          {option.fr_FR}{" "}
                        </span>
                      ))
                    }
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="standard"
                        placeholder={props.placeholder}
                        onChange={(e) => setSubject(e.target.value)}
                        name={props.name}
                        InputProps={{
                          ...params.InputProps,
                          startAdornment: <span className=""></span>,
                          type: "search",
                          endAdornment: (
                            <React.Fragment>
                              {loading ? (
                                <CircularProgress color="inherit" size={2} />
                              ) : null}
                              {params.InputProps.endAdornment}
                            </React.Fragment>
                          ),
                        }}

                        sx={{
                          width: "100%",
                          paddingTop: '-3rem',
                          "& .MuiInputBase-root": {
                            width: "100%",
                            border: "none"
                          },
                          "& .MuiInputBase-input": {
                            width: "100%",
                            // fontSize: `${props.sizes}px`,
                            fontFamily: brandConfig.fontFamily,
                            border: "none"
                          },
                          "& fieldset": {
                            border: "none",
                          },
                        }}
                      />
                    )}
                  />
                </ThemeProvider>
              </div>
            }
          </>
      }
    </>
  );
}